import React, { useState } from "react";
import { GeoJsonDataSource } from "resium";
import { Color as CesiumColor } from "cesium";
function Layers(props) {
  const [hideShow, setHideShow] = useState(true);
  props.hideShowDataRef.current = { hideShow, setHideShow };
  return (
    <>
      <GeoJsonDataSource
        data={"Willow_Boundary.geojson"}
        clampToGround={true}
        //FillColor = {CesiumColor.GREEN}
        strokeWidth={5}
        show={hideShow}
        fill={CesiumColor.PLUM.withAlpha(0.5)}
        stroke={CesiumColor.PLUM}
      />

      <GeoJsonDataSource
        data={"Netley_Grassmere_Boundary.geojson"}
        clampToGround={true}
        //FillColor = {CesiumColor.GREEN}
        strokeWidth={5}
        show={hideShow}
        fill={CesiumColor.FORESTGREEN.withAlpha(0.5)}
        stroke={CesiumColor.FORESTGREEN}
      />

      <GeoJsonDataSource
        data={"Flowlines.geojson"}
        clampToGround={true}
        //FillColor = {CesiumColor.GREEN}
        strokeWidth={2}
        stroke={CesiumColor.DARKBLUE}
      />
    </>
  );
}

export default Layers;
